import { useQuery, useMutation } from "react-query";

import { getGlobalProducts, getAvailableProducts, getBulkProductSuggestions, getSeasonsData } from "@/api/Maintainers/Products/products-query";
import { saveProductBulkCustomer } from "@/api/Maintainers/Products/products-mutation";

const key = "products";

export function useProducts(params) {
	return useQuery([key + "-global", params], () => params && getGlobalProducts(params), {
		enabled: params.get_all !== "",
	});
}

export function useProductsAvailable(option) {
	return useQuery([key + "-available"], () => getAvailableProducts(), {
		enabled: ["agregar", "etiquetados"].includes(option),
		staleTime: -1,
		cacheTime: -1,
	});
}

export function useSaveProductBulkCustomer() {
	return useMutation(saveProductBulkCustomer);
}

export function useBulkProductSuggestions() {
	return useMutation(getBulkProductSuggestions);
}

export function useSeasonsData() {
	return useMutation(getSeasonsData);
}
